import './generic_rule.js.coffee'

class Monitoring.Models.ProfileRule extends Monitoring.Models.GenericRule
  urlRoot: '/monitoring/profile_rules'

class Monitoring.Collections.ProfileRulesCollection extends Backbone.Collection
  model: Monitoring.Models.ProfileRule
